import {FC} from 'react'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useIntl} from 'react-intl'

const Error403: FC = () => {
  const intl = useIntl()
  return (
    <>
      {/* begin::Title */}
      <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>Acesso Negado</h1>
      {/* end::Title */}

      {/* begin::Text */}
      <div className='fw-semibold fs-6 text-gray-500 mb-7'>
        Você não tem permissão para acessar esta página.
      </div>
      {/* end::Text */}

      {/* begin::Illustration */}
      <div className='mb-10'>
        <img
          src={toAbsoluteUrl('/media/logos/taskrush.svg')}
          className='mw-100 mh-200px theme-light-show'
          alt=''
        />
        <img
          src={toAbsoluteUrl('/media/logos/taskrush.svg')}
          className='mw-100 mh-200px theme-dark-show'
          alt=''
        />
      </div>
      {/* end::Illustration */}

      {/* begin::Link */}
      <div className='mb-0'>
        <Link to='/dashboard' className='btn btn-sm btn-primary'>
          {intl.formatMessage({id: 'GENERAL.RETURN'})}
        </Link>
      </div>
      {/* end::Link */}
    </>
  )
}

export {Error403}

